/* Evis Design — live collection filters (patch P28).
   Intercepts the facets form and swaps the results region in place via the
   Section Rendering API. Without JS, the form behaves exactly as before. */
(function () {
  var root = document.getElementById('MainCollection');
  if (!root) return;
  var sectionId = root.getAttribute('data-section-id');
  var swap = document.getElementById('FilterSwap');
  var status = document.getElementById('FilterStatus');
  if (!swap || !sectionId) return;

  var seq = 0;
  var controller = null;
  var timer = null;

  function formUrl(form) {
    var params = new URLSearchParams(new FormData(form));
    var qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function captureFocus() {
    var a = document.activeElement;
    if (a && a.name && swap.contains(a)) {
      return { name: a.name, value: a.value };
    }
    return null;
  }

  function restoreFocus(key) {
    if (!key || typeof CSS === 'undefined' || !CSS.escape) return;
    var el = swap.querySelector(
      'input[name="' + CSS.escape(key.name) + '"][value="' + CSS.escape(key.value) + '"]'
    );
    if (el) el.focus();
  }

  function groupKey(d) {
    var s = d.querySelector('summary');
    return s ? s.textContent.trim().replace(/\s+/g, ' ').replace(/\s*\(\d+\)$/, '') : '';
  }

  function captureOpen() {
    var open = {};
    var list = swap.querySelectorAll('details');
    for (var i = 0; i < list.length; i++) {
      if (list[i].open) open[groupKey(list[i])] = true;
    }
    return open;
  }

  function restoreOpen(open) {
    var list = swap.querySelectorAll('details');
    for (var i = 0; i < list.length; i++) {
      if (open[groupKey(list[i])]) list[i].open = true;
    }
  }

  function fetchSwap(url, push, keepOpen) {
    var my = ++seq;
    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;
    swap.classList.add('filters-loading');
    swap.style.minHeight = swap.offsetHeight + 'px';
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: controller ? controller.signal : undefined
    })
      .then(function (r) {
        if (!r.ok) throw new Error('fetch failed');
        return r.text();
      })
      .then(function (html) {
        if (my !== seq) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('FilterSwap');
        if (!fresh) throw new Error('no swap region');
        var focusKey = captureFocus();
        var openGroups = keepOpen === false ? {} : captureOpen();
        swap.innerHTML = fresh.innerHTML;
        restoreOpen(openGroups);
        restoreFocus(focusKey);
        var strong = swap.querySelector('.coll-head strong');
        if (strong && status) status.textContent = strong.textContent + ' pieces';
        if (push) history.pushState({ filters: true }, '', url);
        swap.classList.remove('filters-loading');
        swap.style.minHeight = '';
      })
      .catch(function (err) {
        if (my !== seq) return;
        if (err && err.name === 'AbortError') return;
        window.location.href = url;
      });
  }

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'FacetsForm') {
      e.preventDefault();
      fetchSwap(formUrl(e.target), true);
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    var f = t && t.form;
    if (!f || f.id !== 'FacetsForm') return;
    if (t.type === 'checkbox' || t.type === 'number') {
      clearTimeout(timer);
      timer = setTimeout(function () {
        fetchSwap(formUrl(f), true);
      }, 150);
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var a = e.target.closest('a');
    if (!a || !swap.contains(a)) return;
    if (
      a.closest('.pagination') ||
      a.closest('.chips') ||
      a.closest('.empty-note') ||
      a.classList.contains('facets__clear')
    ) {
      var href = a.getAttribute('href');
      if (!href) return;
      e.preventDefault();
      var u = new URL(href, window.location.href);
      var isClearAll = a.classList.contains('facets__clear') || a.classList.contains('chips__clear');
      fetchSwap(u.pathname + u.search, true, !isClearAll);
    }
  });

  window.addEventListener('popstate', function () {
    fetchSwap(window.location.pathname + window.location.search, false);
  });
})();
